export default __webpack_public_path__ + "static/media/59.04f2fb57.png";